<template>
  <el-container>
    <el-main>
      <template v-for="(item,index) in shareClassList">
        <div><a v-bind:name="item.title"></a></div>
        <div class="content-title" v-if="!item.child"><span class="el-icon-setting " style="margin-right: 10px"></span>{{item.name}}
        </div>
        <el-row :gutter="20">
          <template v-for="(k,index) in shareItemList[item.title]">
            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="8" :span="6">
              <div class="grid-content bg-purple">
                <el-card class="box-card" style="height: 200px;" :body-style="{ height: '78px', overflowY:'auto'}">
                  <div slot="header" class="clearfix" style="position: relative">
                    <strong><span>{{k.name}}</span></strong>
                    <img class="content-img" :src="'./static/image/'+k.icon+'.png'">
                  </div>
                  <el-scrollbar style="height:100%;">
                    <div class="text item">
                      {{k.introduction}}
                    </div>
                  </el-scrollbar>

                </el-card>
                <span class="time-label">{{k.created_time}}</span>
                <a target="_blank" v-bind:href="k.url">
                  <el-button style="  position: relative; bottom: 31px; right: 18px;float: right; padding: 3px 0"
                             type="text">
                    <span v-if="k.type==='href'">链接直达</span>
                    <span v-else-if="k.type==='download'">直接下载</span>
                  </el-button>
                </a>
              </div>
            </el-col>
          </template>
        </el-row>
      </template>
    </el-main>
    <div style="position: absolute;right: 50px;bottom: 50px;font-size: 30px;background-color: #fff">
      <span @click="openModal()" class="el-icon-circle-plus-outline" style="color: #ff0000;cursor: pointer" title="添加我的网站"></span>
    </div>
    <el-dialog
  title="提交链接"
  center
  destroyOnClose
  :closeOnClickModal='false'
  :visible.sync="dialogVisible"
  width="30%">
  
  <el-form :model="formInline"  :rules="rules" ref="ruleForm"  :label-position="'top'" class="demo-form-inline">
    <el-form-item label="链接名称" prop="name">
    <el-input v-model="formInline.name" placeholder="请输入链接名称"></el-input>
  </el-form-item>
  
  <el-form-item label="网址描述"  prop="describe"> 
    <el-input type="textarea" v-model="formInline.describe" placeholder="请输入网址描述"></el-input>    
  </el-form-item>
  <el-form-item label="链接地址" prop="link">
    <el-input v-model="formInline.link" placeholder="请输入链接地址"></el-input>
  </el-form-item>
    <el-form-item label="验证码"  prop="cpk"> 
    <el-input type="text"  style="width:30%" v-model="formInline.cpk" placeholder="请输入验证码"></el-input>    
        <el-image style="    height: 25px;
    display: inline-table;" :src="src"></el-image>

  </el-form-item>
</el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submit('ruleForm')">确 定</el-button>
  </span>
</el-dialog>
  </el-container>
</template>
<style>
  .content-title {
    font-size: 2em;
    padding: 10px 0;
  }

  .time-label {
    position: relative;
    bottom: 28px;
    font-size: 11px;
    color: gray;
    margin: 24px;
  }

  .content-img {
    width: 32px;
    height: 32px;
    position: absolute;
    right: 0;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }
  .el-dialog__body{
    padding: 0 20px;
  }
</style>
<script>
  import trans from '../transform/trans'
  import {getShareList, getShareAll,postMsg, getCpk} from '../services/shareService'
  import {toLowerCase} from "../transform/httpAjax";
import { share } from '../vue.config';

  export default {
    data() {
      return {
         formInline: {
          link: '1',
          describe: '1',
          name:'1',
          cpk:'1'
        },
        rules: {name: [
            { required: true, message: '请输入链接名称', trigger: 'blur' }
          ],
          link: [
            { required: true, message: '请输入链接地址', trigger: 'blur' }
          ],
          describe: [
            { required: true, message: '请输入网址描述', trigger: 'blur' }
          ],
          cpk: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ]
          },
        src:share+"/getCaptcha",
        dialogVisible:false,
        uniqueOpened: true,
        TabsValue: '',
        editableTabsValue2: '2',
        editableTabs2: [],
        tabIndex: 2,
        shareClassList: [],
        shareItemList: []
      }
    },
    beforeMount() {


    },
    mounted() {

    },
    beforeCreate() {

    },
    created() {
      var self = this;
      getShareList()
        .then(function (res) {
          self.shareClassList = toLowerCase(res.data.list);
          console.log(self.shareClassList)
        })
        .catch(res => {
          console.log(res)
        });
      getShareAll()
        .then(function (res) {
          // self.shareItemList=res.data.list;//self.initListToJSON(res.data.list);
          self.shareItemList = self.initListToJSON(toLowerCase(res.data.list));
          console.log(self.shareItemList)
        })
        .catch(res => {
          console.log(res)
        });
      var self = this;
      trans.$on('select-slider', function (data) {
        if (data) {
          document.getElementsByName(data.title)[0].scrollIntoView();
        }
      });
    },
    methods: {
      openModal(){
        this.dialogVisible=true;
        console.log(1234);
      },
      submit(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {   
            console.log(this.formInline)         
              postMsg(this.formInline)
              .then((res) =>{
                // self.shareItemList=res.data.list;//self.initListToJSON(res.data.list);
                if(res.data.status){
                  this.dialogVisible=false;
                  this.$message("提交成功");
                  // this.src=share+"/getCaptcha";
                  this.$refs[formName].resetFields()
                }else{
                  this.$message(res.data.info);
                }
              })
              .catch(res => {
                console.log(res)
              })
          } else {
             this.$message("请补全信息！");
          }
        });
      },
      initListToJSON(list) {
        var j = {};
        for (var i = 0, length = list.length; i < length; i++) {
          if (j[list[i]['classtype_en']]) {
            j[list[i]['classtype_en']].push(list[i])
          } else {
            j[list[i]['classtype_en']] = [];
            j[list[i]['classtype_en']].push(list[i])
          }
        }
        return j;
      },
      initContent(lists) {
        console.log(lists)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Main.vue